import { render } from "./PlayerProfile.vue?vue&type=template&id=211d0417"
import script from "./PlayerProfile.vue?vue&type=script&lang=js"
export * from "./PlayerProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/PlayerProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "211d0417"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('211d0417', __exports__)) {
    api.reload('211d0417', __exports__)
  }
  
  module.hot.accept("./PlayerProfile.vue?vue&type=template&id=211d0417", () => {
    api.rerender('211d0417', render)
  })

}


export default __exports__